import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import {
  GetComplianceInvestigationDetailsAsync,
  IComplianceInvestigationDetails,
} from "./IComplianceInvestigation";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";

export interface IComplaint {
  complaintid: string;
  type: string;
  reference: string;
  subject: string;
  status: string;
  licenceid: string;
  licenceprofileid: string;
  datereceived: string;
  closeddate: string;
  complianceinvestigationid: string;
  dateoccurred: string;
  durationofoccurance: string;
}

export interface IComplaintDetails extends IDetailsResponse {
  complaintid: string;
  type: string;
  reference: string;
  subject: string;
  status: string;
  licenceid: string;
  licenceprofileid: string;
  datereceived: string;
  closeddate: string;
  complianceinvestigationid: string;
  dateoccurred: string;
  durationofoccurance: string;
  licence_regno: string;
  complianceInvestigationDetails?: IComplianceInvestigationDetails;
}

/*
    "complaintid": "4dc8ca34-a149-ea11-a324-0050568a2d1a",
    "type": "Complaint",
    "reference": "COM009932",
    "subject": "P0510-01, 06/02/20, Noise",
    "status": "Closed",
    "licenceid": "2ec7e87d-7c61-e211-9eb5-0050568a69e2",
    "licenceprofileid": "17481eff-ef09-4b71-b89d-f99ff3094e0f",
    "datereceived": "2020-02-06T00:00:00",
    "closeddate": "2020-03-27T00:00:00",
    "complianceinvestigationid": null,
    "dateoccurred": "2020-02-06T00:00:00",
    "durationofoccurance": "Ongoing"
*/

export const GetComplaintsFromComplianceInvestigationFetchUrl = (
  complianceInvestigationId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/Complaint/listbyciid?ci_id=${complianceInvestigationId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/complaints-ci`;
  }

  return url;
};

export async function GetComplaintDetailsAsync(
  complaintId: string
): Promise<IComplaintDetails> {
  var url = `${API_URL}/Complaint/byid?complaint_id=${complaintId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/complaint-details`;
  }

  var response = await fetch(url);
  var body = <IComplaintDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  if (body.complianceinvestigationid) {
    body.complianceInvestigationDetails =
      await GetComplianceInvestigationDetailsAsync(
        body.complianceinvestigationid
      );
  }

  return <IComplaintDetails>{
    response: response,
    complaintid: body.complaintid,
    type: body.type,
    reference: body.reference,
    subject: body.subject,
    status: body.status,
    licenceid: body.licenceid,
    licenceprofileid: body.licenceprofileid,
    datereceived: formatDate(body.datereceived),
    closeddate: formatDate(body.closeddate),
    dateoccurred: formatDate(body.dateoccurred),
    durationofoccurance: body.durationofoccurance,
    complianceinvestigationid: body.complianceinvestigationid,
    complianceInvestigationDetails: body.complianceInvestigationDetails,
    licence_regno: licenceDetails.reg_no,
  };
}
